import React, { useContext, Fragment, useState, useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'

import ActionEdit from './edit'
import ActionDelete from './delete'
import ActionProcess from './processContent'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}))

const Index = (props) => {
  const classes = useStyles()
  const { user, item } = props // action props

  return (
    <Fragment>
      <div className={classes.root}>
        <ActionEdit {...props} />
        <ActionDelete {...props} />
        <ActionProcess {...props} />
      </div>
    </Fragment>
  )
}

export default Index
